module.exports = __webpack_public_path__ + "img/teamImg32.b2eb3189.jpg";